import { render, staticRenderFns } from "./CurrentMenuPanel.vue?vue&type=template&id=456e40bc&scoped=true&"
import script from "./CurrentMenuPanel.vue?vue&type=script&lang=js&"
export * from "./CurrentMenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMenuPanel.vue?vue&type=style&index=0&id=456e40bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e40bc",
  null
  
)

export default component.exports